import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { ApiServiceService } from "../../../Services/api-service.service";
import { Utils } from "../../../Shared/utils";

@Component({
  selector: "app-view-mda-bill-details",
  templateUrl: "./view-mda-bill-details.component.html",
  styleUrls: ["./view-mda-bill-details.component.css"],
})
export class ViewMdaBillDetailsComponent implements OnInit {
  @Output() onConfirmClicked = new EventEmitter();
  loading: boolean;
  @Input() billDetails: any;
  submitting: boolean;
  userName: string;

  constructor(
    private bsModalRef: BsModalRef,
    private apiService: ApiServiceService,
  ) {}

  ngOnInit(): void {
    console.log(this.billDetails);
    this.getUserDetails(this.billDetails?.createdBy);
  }

  close(): void {
    this.bsModalRef.hide();
  }

  getUserDetails(id: number): void {
    const url = `auth/user/details/${id}`;
    this.apiService.LoginGet(url).subscribe(
      (v) => {
        this.userName = v?.displayname;
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  get currencySymbol(): string {
    return Utils.currencySymbol("NGN");
  }
}
